
function Investigacion() {
  return (
    <div>Investigacion</div>
  )
}

export default Investigacion